import { defineStore } from "pinia";

import { ref, computed } from 'vue'

import axios from 'axios'

export const useUploadStoreVdo = defineStore('useUploadStoreVdo', () => {

  const selectedFiles = ref([]);

  const errorMsg = ref("");

  const isUploading = computed(() =>
    selectedFiles.value.some((file) => file.status == "uploading")

  );

  const pending_count = computed(() =>
    selectedFiles.value.filter(file => file.status == "pending").length

  );

  const failed_count = computed(() =>
    selectedFiles.value.filter(file => file.status == "failed").length

  );

  const success_count = computed(() =>
    selectedFiles.value.filter(file => file.status == "success").length

  );

  const waitForBrowser = () => {
    return new Promise((resolve) => {
      setTimeout(resolve, 0)
    });
  };

  const getVideoDuration = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      const url = URL.createObjectURL(file);
      const startedAt = performance.now();
      const cleanup = () => {
        URL.revokeObjectURL(url);
        video.removeAttribute('src');
        video.load();
      };

      video.preload = 'metadata';
      video.src = url;
      video.onloadedmetadata = () => {
        const duration = video.duration;
        console.info('[upload_vdo] metadata loaded', {
          fileName: file.name,
          fileType: file.type,
          fileSize: file.size,
          duration,
          readyState: video.readyState,
          elapsedMs: Math.round(performance.now() - startedAt),
        });
        cleanup();
        resolve(duration);
      };
      video.onerror = () => {
        const mediaErrorCode = video.error ? video.error.code : null;
        const mediaErrorMessage = video.error ? video.error.message : null;
        console.error('[upload_vdo] metadata load failed', {
          fileName: file.name,
          fileType: file.type,
          fileSize: file.size,
          readyState: video.readyState,
          networkState: video.networkState,
          mediaErrorCode,
          mediaErrorMessage,
          canPlayTypeMp4: video.canPlayType('video/mp4'),
          elapsedMs: Math.round(performance.now() - startedAt),
        });
        cleanup();
        resolve(null);
      };
    });
  };

  const checkVideoDurations = async (files, minDurationSec, maxDurationSec) => {
    const durationCheckConcurrency = Number(process.env.VUE_APP_DURATION_CHECK_CONCURRENCY) || 3;
    const workerCount = Math.min(durationCheckConcurrency, files.length);
    const validFiles = new Array(files.length);
    const invalidFiles = [];
    let nextFileIndex = 0;

    const checkNextFile = async () => {
      while (nextFileIndex < files.length) {
        const fileIndex = nextFileIndex;
        nextFileIndex++;

        const file = files[fileIndex];
        const duration = await getVideoDuration(file);
        const hasReadableDuration = Number.isFinite(duration);
        const isDurationOutOfRange = hasReadableDuration && (duration < minDurationSec || duration > maxDurationSec);

        if (isDurationOutOfRange) {
          invalidFiles.push({
            name: file.name,
            durationText: Number.isFinite(duration)
              ? `${duration.toFixed(1)}s`
              : 'อ่านความยาววิดีโอไม่ได้',
          });
        } else {
          if (!hasReadableDuration) {
            console.warn('[upload_vdo] duration check skipped (unreadable duration)', {
              fileName: file.name,
              fileType: file.type,
              fileSize: file.size,
            });
          }
          validFiles[fileIndex] = {
            file: file,
            percentage: 0,
            status: "pending",
          };
        }

        if (fileIndex % 20 === 0) {
          await waitForBrowser();
        }
      }
    };

    await Promise.all(Array.from({ length: workerCount }, () => checkNextFile()));

    return {
      validFiles: validFiles.filter(Boolean),
      invalidFiles: invalidFiles,
    };
  };

  const onSelectFiles = async (event) => {
    const target = event.target;
    if (target.files === null) {
      return;
    }

    clearFiles();

    const allFiles = Array.from(target.files);
    const mp4Files = allFiles.filter((file) => file.name.toLowerCase().endsWith(".mp4"));
    const rejectedCount = allFiles.length - mp4Files.length;

    if (rejectedCount > 0) {
      alert(`ระบบอนุญาติให้ upload แค่ไฟล์ .mp4 เท่านั้น\nพบไฟล์ที่ไม่ใช่ .mp4 จำนวน ${rejectedCount} ไฟล์ ซึ่งถูกยกเว้นออกจากรายการ`);
    }

    const MIN_DURATION_SEC = Number(process.env.VUE_APP_MIN_DURATION_SEC) || 5;
    const MAX_DURATION_SEC = Number(process.env.VUE_APP_MAX_DURATION_SEC) || 30;
    const { validFiles, invalidFiles } = await checkVideoDurations(mp4Files, MIN_DURATION_SEC, MAX_DURATION_SEC);

    selectedFiles.value = validFiles;

    if (invalidFiles.length > 0) {
      const alertFileLimit = 20;

      const fileList = invalidFiles.slice(0, alertFileLimit).map((file) => `• ${file.name} (${file.durationText})`).join('\n');
      const moreText = invalidFiles.length > alertFileLimit ? `\n...และอีก ${invalidFiles.length - alertFileLimit} ไฟล์` : '';
      alert(`ระบบอนุญาติให้ upload วีดีโอที่มีความยาวระหว่าง ${MIN_DURATION_SEC}-${MAX_DURATION_SEC} วินาทีเท่านั้น\nพบไฟล์ที่ไม่ผ่านเงื่อนไข จำนวน ${invalidFiles.length} ไฟล์:\n${fileList}${moreText}`);
    }
  };

  const clearFiles = () => {
    selectedFiles.value = []
    errorMsg.value = ""
  };

  const uploadFile = ( file, onUploadProgress, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment,capture_tag_sec) => {

     if(Number(file.size/10000).toFixed(0) < Number(15)){
       return new Promise((resolve, reject) => {
          errorMsg.value = "***ขนาดไฟล์ต้องไม่ต่ำกว่า 150KB"
          reject("ขนาดไฟล์ต้องไม่ต่ำกว่า 150KB");
        });
      
    }
    return axios.post("v1/upload/idp-vdo", {
      event_id: event_id,
      photographer_id: user_id,
      original_file_name: file.name
    })
    .then((response) => {
      if(response.data.is_duplicate === 'Y'){
        return "skip"
      }else{
        return axios.post("v1/upload/sign-vdo", {
          event_key: event_key,
          file_name: file.name,
          file_type: "video/mp4"
        },)
        .then((presigned_response) => {
          return axios.put(presigned_response.data.url, file, {
            headers: {
              "Content-Type": "video/mp4",
              "Content-Disposition": `inline; filename="${presigned_response.data.file_name}"`,
            },
            onUploadProgress,
          })
          .then((put_response) => {

            if(put_response.status === 200){
              return axios.post("v1/upload/check-vdo", {
              photographer_id: user_id,
              event_key: event_key,
              event_id: event_id,
              event_watermark_hori: event_watermark_hori,
              event_watermark_vertical: event_watermark_vertical,
              is_free_download: is_free_download,
              is_add_watermark_for_free_download: is_add_watermark_for_free_download,
              is_event_stage: is_event_stage,
              event_stage: event_stage,
              new_file_name: presigned_response.data.file_name,
              original_file_name: file.name,
              is_mhao: is_mhao,
              is_hybrid: is_hybrid,
              is_mhao_hybrid: is_mhao_hybrid,
              is_image_addjustment: is_image_addjustment,
              capture_tag_sec: capture_tag_sec
            })
            .then((prepare_response) => {
            });
            }    
            
          });


        });
      }
    }); 
  };

  const sleep_only = async () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true)
      },20)
    });
  }

  const sleep_upload_slow_upload = async () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true)
      }, 500)
    });
  }

  const sleep_upload_slow_upload_api = async () => {
    return new Promise((resolve, reject) => {
        return axios.get("https://yjdxyhjl7eirggm42hjju74ze40nfxyx.lambda-url.ap-southeast-1.on.aws", null,)
        .then((response) => {
          resolve(true)       
        });
    });
  }

  const call_upload_file = ( file, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download,is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment,capture_tag_sec) => {

    return new Promise((resolve, reject) => {
      file.status = "uploading";
      file.percentage = 0;
      uploadFile( file.file, (event) => {
        file.percentage = Math.round((100 * event.loaded) / event.total);
      }, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download,is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment,capture_tag_sec)
        .then((response) => {
          file.status = "success";
          resolve(true)
        })
        .catch(() => {
          file.status = "failed";
          resolve(false)
        });
    });
  }

  const uploadSelectedFiles = async (event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,
    server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,credit_balance,is_image_addjustment,capture_tag_sec) => {

    if(is_hybrid === 'Y' && is_mhao_hybrid === 'N'){
      let check_pending = selectedFiles.value.filter(file => file.status == "pending").length 
      if(check_pending > credit_balance){
        alert("เครดิตสำหรับการ upload ไม่เพียงพอกรุณาเติมเครดิต")
        return false;
      }
    }
    let check_failed = selectedFiles.value.filter(file => file.status == "failed").length
    let check_success = selectedFiles.value.filter(file => file.status == "success").length
    if (check_success === selectedFiles.value.length) {
      if(check_success===0){
        alert("Please choose file befor upload")
      }else{
        alert("All files uploaded")
      }
    }else if(is_event_stage === 'Y' && event_stage===0){
      alert("Please choose stages,location befor upload")
    } else {

      if (check_failed > 0) {
        //retry only fial
        let counter = 0
        let array_size = selectedFiles.value.length;
        while (counter < array_size) {
          let _uploading_count = selectedFiles.value.filter(file => file.status == "uploading").length
          if(_uploading_count <= 10){

            if (selectedFiles.value.length > 0) {
              let file = selectedFiles.value[counter];
              if(file.status !== 'success'){
                 call_upload_file( file, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment,capture_tag_sec)
              }
            }
            counter++
          }else{
            await sleep_upload_slow_upload_api();
          }
        }
      } else {
        let counter = 0;
        let array_size = selectedFiles.value.length;
        let thead_upload = 10;
        while (counter < array_size) {
          let _uploading_count = selectedFiles.value.filter(file => file.status == "uploading").length
          if(_uploading_count <= thead_upload){
            if (selectedFiles.value.length > 0) {
              let file = selectedFiles.value[counter];
              if(file.status !== 'success'){
                call_upload_file( file, event_key, event_watermark_hori, event_watermark_vertical, user_id, event_id,server_upload_url_text,server_upload_url_aws,is_free_download, is_add_watermark_for_free_download,is_event_stage,event_stage,is_mhao,is_hybrid,is_mhao_hybrid,is_image_addjustment,capture_tag_sec)
              }
            }
            counter++
        }else{
          await sleep_upload_slow_upload_api();
        }
        }
      }
    }
  }

  return { selectedFiles, isUploading, pending_count,  failed_count, success_count, onSelectFiles, clearFiles, uploadSelectedFiles, errorMsg }
});